"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
const generic_parser_1 = require("generic-parser");
const env_1 = require("./env");
const factory_1 = __importDefault(require("./factory"));
const _lines_1 = __importDefault(require("./rules/$lines"));
const makeMatchContextString = (context, target) => {
    const { offset, prevRule, prevContext } = context;
    const expected = prevRule.toString();
    const newLineOffsetBefore = target.lastIndexOf("\n", offset);
    const newLineOffsetAfter = target.slice(offset).search(/\r?\n/);
    // eslint-disable-next-line no-irregular-whitespace
    const subString = (target.slice(newLineOffsetBefore + 1, offset) + "▸" + target.slice(offset, offset + newLineOffsetAfter)).replace(/ /g, "･").replace(/　/g, "⬚");
    const pos = (0, generic_parser_1.getMemorizedStringOffsetToPos)()(target, offset);
    return `Location: ${JSON.stringify(pos)}
Expected: ${expected}
${subString}

${prevContext ? makeMatchContextString(prevContext, target) : ""}`;
};
const $start = factory_1.default
    .sequence(c => c
    .and(() => _lines_1.default, "lines")
    .and(r => r
    .nextIsNot(r => r.anyOne()))
    .action((({ lines }) => {
    return lines;
})));
const parse = (lawtext, options = {}) => {
    const env = (0, env_1.initialEnv)(options);
    const target = lawtext.endsWith("\n") ? lawtext : lawtext + "\r\n";
    const result = $start.match(0, target, env);
    if (result.ok)
        return result.value;
    throw new Error(`Parse error:
MatchFail at max offset:

${env.state.maxOffsetMatchContext && makeMatchContextString(env.state.maxOffsetMatchContext, target)}
`);
};
exports.parse = parse;
exports.default = exports.parse;
//# sourceMappingURL=parse.js.map